import { render } from "./StudentStandartCarrying.vue?vue&type=template&id=8e024356"
import script from "./StudentStandartCarrying.vue?vue&type=script&lang=js"
export * from "./StudentStandartCarrying.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__